import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gener-slider-simmer',
  templateUrl: './gener-slider-simmer.component.html',
  styleUrls: ['./gener-slider-simmer.component.css']
})
export class GenerSliderSimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
